import Tag from "./Tag";
import { getClassLabel, getObjectLabel } from "../utils/label";
import ConditionFunctions from "./conditionFunctions"

export default class MetadataBase{
  static ConditionFunctionRegistry = { ...ConditionFunctions };

  /**
   *
   * @param {Element} node
   * @param {import("./XMLRDBNavigation").default} xmlRDBNavigation
   */
  constructor(node, xmlRDBNavigation, parentMeta) {
    this.parentMetadata = parentMeta;
    this.root = xmlRDBNavigation;
    this.tags = [];
    this._tagsByName = {}; /** cache-Objekt um wiederholte Tagauswertung zu beschleunigen */
    this._inheritedTagsByName = {} ;/** cache-Objekt um wiederholte Tagauswertung zu beschleunigen */
    this._tagsStartWith = {}; /** cache-Objekt um wiederholte Tagauswertung zu beschleunigen */
    this._nodeAttributes = {};

    if (node.attributes) {
      for (let i = 0; i < node.attributes.length; i++) {
        let item = node.attributes.item(i);
        this._nodeAttributes[item.name] = item.value;
      }
    }

    node.childNodes.forEach(child => {
      if (child.nodeName && child.nodeName === "meta:Tag") {
        this.tags.push(new Tag(child));
      }
    });
  }

  /**
   * @returns {import("./Element").default}
   */
  element() {
    let metadata = this;
    while (metadata.parentMetadata) { metadata = metadata.parentMetadata; }
    // @ts-ignore
    return metadata;
  }

  tagsByNames(names) {
    let result = [];
    for (let i = 0; Array.isArray(names) && i < this.tags.length; i++){
      let idx = names.indexOf(this.tags[i].name());
      if (idx !== -1) {
        result.push(idx);
      }
    }
    return result;
  }

  /**
   *
   * @param {string} name
   * @returns {Array<Tag>}
   */
  tagsByName(name) {
    if (this._tagsByName.hasOwnProperty[name]) {
      return this._tagsByName[name];
    }
    let result = this.tags.filter(tag => tag.name() === name);
    this._tagsByName[name] = result;
    return result;
  }

  tagsStartWith(name) {
    if (this._tagsStartWith.hasOwnProperty[name]) {
      return this._tagsStartWith[name];
    }
    let result = this.tags.filter(tag => tag.name().startsWith(name));
    this._tagsStartWith[name] = result;
    return result;
  }

  getNodeAttribute(name) {
    return this._nodeAttributes[name];
  }

  /**
   *
   * @param {string} name
   * @returns {Tag}
   */
  tagByName(name) {
    let tags = this.tagsByName(name);
    return tags.length? tags[0] : null;
  }
  
  tagValuesByName(name) {
    let tags = this.tagsByName(name);
    let result = [];
    for (let i = 0; Array.isArray(tags) && i < tags.length; i++){
      result.push(tags[i].value());
    }
    return result;
  }

  /**
   *
   * @param {string} name
   * @returns {string}
   */
  tagValueByName(name) {
    return this.tagByName(name)?.value();
  }

  getInheritedTags(name) {
    if (this._inheritedTagsByName.hasOwnProperty[name]) {
      return this._inheritedTagsByName[name];
    }    
    let tags = this.tagsByName(name);
    if (tags.length === 0 && this.parentMetadata) {
      tags = this.parentMetadata.getInheritedTags(name);
    }
    this._inheritedTagsByName[name] = tags;
    return tags;
  }

  isVisible(dataElement) {
    const visible = this.tagByName("Visibility");
    if (visible) return visible.value() === "true";
    const visibilityFunctionName = this.tagValueByName("VisibilityFunction");
    if (visibilityFunctionName) {
      const visibilityFunction = MetadataBase.ConditionFunctionRegistry[visibilityFunctionName];
      if (!visibilityFunction) {
        throw `Unbekannte Visibility-Funktion '${visibilityFunctionName}'`;
      }      
      return visibilityFunction(this,dataElement);
    }
    return true;
  }

  /**
   *
   */
  classLabel(html = true) {
    let label = getClassLabel(this.tags, html);
    // @ts-ignore
    return label.trim() ?? this.name();
  }

    /**
   *
   * @param {import("../xmlrdb-data/DataElement").default} dataElement
   */
  objectLabel(dataElement, html = true) {
    if(this.root.translationProvider) {
      return this.root.translationProvider.getLabel(this);
    }
    let subObjectClassName = this.tagByName("SubObjectLabel")?.value();
    let compLabel = getObjectLabel(dataElement, this.tags, html);
    if (subObjectClassName) {
      let subDataElements = dataElement.subElements[subObjectClassName].dataElements;
      if (subDataElements.length) {
        dataElement = subDataElements[0];
      }
      else {
        dataElement = null;
      }
    }
    return compLabel();
  }

  label() {
    if(this.root.translationProvider) {
      return this.root.translationProvider.getLabel(this);
    }
    let labelTags = this.tagsByName("Label");
    if (labelTags.length) {
      return labelTags.reduce((acc, val) => { return acc + val.value() }, "");
    }
    else {
      // @ts-ignore
      return typeof this.name === "function" ? this.name() : "";
    }
  }

  /**
   *
   * @param {import("../xmlrdb-data/DataElement").default | import("../xmlrdb-data/Attribute").default} dataElementOrAttribute
   * @returns
   */
  onChangeReenterPassword(dataElementOrAttribute) {
    if(this.tagByName("onChangeReenterPassword")){
      const ReenterPasswordFunctionName = this.tagValueByName("ReenterPasswordFunction");
      if (ReenterPasswordFunctionName) {
        const ReenterPasswordFunction = MetadataBase.ConditionFunctionRegistry[ReenterPasswordFunctionName];
        if (!ReenterPasswordFunction) {
          throw `Unbekannte ReenterPassword-Funktion '${ReenterPasswordFunctionName}'`;
        }
        const dataElement = dataElementOrAttribute.dataElement ? dataElementOrAttribute.dataElement : dataElementOrAttribute;
        return ReenterPasswordFunction(this,dataElement);
      }
      return dataElementOrAttribute.hasChanged.value;
    }
    return false;
  }
}